import * as React from 'react';

import {
  ColumnDef,
  ColumnFiltersState,
  FilterFn,
  SortingState,
  VisibilityState,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';

import DataTableFooter from './DataTableFooter';
import DataTableHeader from './DataTableHeader';
import DataTableTable from './_table';

export interface Props<T> {
  columns: ColumnDef<T>[];
  data: T[];
  searchPlaceholder: string;
  searchColumns: string[];
  toolbarButtons?: React.JSX.Element[];
}

export const DataTable = <T,>({
  columns,
  data,
  searchPlaceholder,
  searchColumns,
  toolbarButtons,
}: Props<T>): React.JSX.Element => {
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [globalFilter, setGlobalFilter] = React.useState('');
  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>(
    []
  );
  const [columnVisibility, setColumnVisibility] =
    React.useState<VisibilityState>({});
  const [rowSelection, setRowSelection] = React.useState({});

  const table = useReactTable({
    data,
    columns,
    // filterFns: {
    //   fuzzy: fuzzyFilter, //define as a filter function that can be used in column definitions
    // },
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    onGlobalFilterChange: setGlobalFilter,
    // globalFilterFn: 'fuzzy', //apply fuzzy filter to the global filter (most common use case for fuzzy filter)
    onRowSelectionChange: setRowSelection,
    state: {
      sorting,
      columnFilters,
      columnVisibility,
      rowSelection,
      globalFilter,
    },
  });

  return (
    <div className="w-full">
      <DataTableHeader
        table={table}
        searchPlaceholder={searchPlaceholder}
        searchColumns={searchColumns}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        toolbarButtons={toolbarButtons}
      />
      <DataTableTable columns={columns} table={table} />
      <DataTableFooter table={table} />
    </div>
  );
};

export default DataTable;
